export const GET_NOTAS_CREDITO_BY_DATE_RANGE_AND_CLIENT = `
	query getAllNotasCreditoByDateRangeAndClientName($startDate: String!, $endDate: String!, $clientName: String!) {
		getAllNotasCreditoByDateRangeAndClientName(startDate: $startDate, endDate: $endDate, clientName: $clientName) {
			id
			fileNumber
			codigo
			fileName
			monto
		}
	}
`;

export const GET_ALL_NOTAS_CREDITO = `
	query {
		getAllNotasCredito {
			id
			codigo
			agencia
			tipo
			fecha
			descripcion
			clientCreatedBy
			monto
			saldo
			keyPdf
			fileNumber
			estado
			itinerarioID
			createdAt
			createdBy
			isAjustePorVariacion
			lstPagos {
				tipo
				id
				monto
			}
		}
	}
`;

export const GET_ALL_NOTAS_CREDITO_PROVEEDORES = `
	query {
		getAllNotasCreditoProveedores {
			id
			codigo
			estado
			fileNumber
			nameProveedor
			reef
			partialPayment
			saf
			penalidad
			numberOS
			idItinerary
			createdAt
			updatedAt
		}
	}
`;

export const UPDATE_NOTA_CREDITO_PROVEEDOR = `
	mutation updateNotaCreditoProveedor($id: String!, $updates: inputNotaCreditoProveedor_Dto!) {
		updateNotaCreditoProveedor(id: $id, updates: $updates) {
			id
			estado
		}
	}
`;
